import { useEffect, useState } from "react";
import { Button, Input } from "reactstrap";
import Label from "./Label";
import { useDataContext } from "../context/DataContext";

const EditEtap = ({etap, handleSave, cancel, terminOd}) => {
  const [nazwa, setNazwa] = useState(etap?.Nazwa);
  const [kategoria, setKategoria] = useState(etap?.Kategoria);
  const [numer, setNumer] = useState(etap?.Numer);
  const [date, setDate] = useState(etap?.Data ?? terminOd);
  const [time, setTime] = useState(etap?.DzienNoc == 'N');
  const [pk, setPk] = useState(etap?.PunktyKontrolne);
  const [length, setLength] = useState(etap?.Dlugosc);
  const [limitPodstawowy, setLimitPodstawowy] = useState(etap?.LimitPodstawowy);
  const [limitSpoznien, setLimitSpoznien] = useState(etap?.LimitSpoznien);
  const [budowa, setBudowa] = useState(etap.Budowniczy ?? []);
  const { budowniczyArray, kategorie } = useDataContext();

  return (
    <>
      <div className='popup-overlay'/>
      <div className="popup-contained">
        <div className='popup-header'>
          {etap.Id > 0 ? 'Edytuj etap' : 'Dodaj etap'}
        </div>
        <div className='popup-body'>
          <div className="impreza-details-group">
            <Label>Kategoria</Label>
            <Input
              type='select'
              value={kategoria}
              onChange={(e) => setKategoria(e.target.value)}
            >
              <option></option>
              {kategorie.map(k => <option key={k}>{k}</option>)}
            </Input>
            <Label>Numer</Label>
            <Input
              type='number'
              value={numer}
              onChange={(e) => setNumer(e.target.value)}
            />
            <Label>Nazwa Etapu</Label>
            <Input
              value={nazwa}
              onChange={(e) => setNazwa(e.target.value)}
            />
            <Label>Termin</Label>
            <Input 
              type='date'
              value={date}
              onChange={(e) => setDate(e.target.value)}
            />
            <Label>Dzień / Noc</Label>
            <Input
              value={time}
              onChange={(e) => setTime(e.target.value)}
            />
            <Label>Ilość PK</Label>
            <Input
              value={pk}
              onChange={(e) => setPk(e.target.value)}
            />
            <Label>Długość</Label>
            <Input
              value={length}
              onChange={(e) => setLength(e.target.value)}
            />
            <Label>Limit podstawowy</Label>
            <Input
              value={limitPodstawowy}
              onChange={(e) => setLimitPodstawowy(e.target.value)}
            />
            <Label>Limit spóźnień</Label>
            <Input
              value={limitSpoznien}
              onChange={(e) => setLimitSpoznien(e.target.value)}
            />
            <Label>Budowa</Label>
            <Input
              type='select'
              value={budowa}
              onChange={(e) => setBudowa(e.target.value)}
              multiple
            >
              <option></option>
              {(budowniczyArray ?? []).map(k => <option key={k.o_key} value={k.o_key}>{k.o_value}</option>)}
            </Input>
          </div>
        </div>
        <div className='popup-footer'>
          <Button color="secondary" outline onClick={cancel}>
            Zamknij
          </Button>
          <Button color="primary" onClick={handleSave} className="popup-footer-submit">
            Zapisz
          </Button>
        </div>
      </div>
    </>
  );
}

export default EditEtap;